// Third-party
import React from 'react';
import classNames from 'classnames';
import { camelCase } from 'lodash';

// Utils
import { THUMBNAIL } from '@/modules/proposal/utils/constants';

type Props = {
  patterns: string[];
  selected?: string;
  onChange?: (pattern: string) => void;
};

class PatternSelector extends React.PureComponent<Props> {
  render() {
    const { patterns, onChange, selected } = this.props;

    return (
      <div className="pattern-selector">
        {patterns.map(pattern => (
          <button
            type="button"
            key={pattern}
            className={classNames('pattern-square', { selected: selected === pattern })}
            style={{ background: pattern }}
            onClick={() => onChange && onChange(pattern)}
          >
            <img src={THUMBNAIL[pattern]} alt={pattern.toString()} />
          </button>
        ))}
      </div>
    );
  }
}

export default PatternSelector;
